var PropTypes = require('prop-types');
var React = require('react');
var Colors = require('../utils/colors');

class BrandLogo extends React.Component {
  static propTypes = {
    width: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]), // dimensions must be strings, because they can include units (e.g. "1.2cm" is valid)
    height: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  };

  render() {
    var logoGrey = Colors.logoGrey;

    return (
      <svg className="c42-brand-logo" viewBox="0 0 99.84 20" {...this.props}>
        <title>Code42_Logo</title>
        <path fill={Colors.logoOrange} d="M10,15a5,5,0,1,1,4.84-6.25H20V0H0V20H20V11.25H14.84A5,5,0,0,1,10,15"/>
        <path fill={logoGrey} d="M24.31,10.09a6,6,0,0,1,6.22-6.22,5.48,5.48,0,0,1,4.92,2.7l-1.8.92a3.61,3.61,0,0,0-3.12-1.75,4.1,4.1,0,0,0-4.06,4.35,4.1,4.1,0,0,0,4.06,4.35,3.57,3.57,0,0,0,3.12-1.75l1.8,0.92a5.5,5.5,0,0,1-4.92,2.7,6,6,0,0,1-6.22-6.22"/>
        <path fill={logoGrey} d="M43.33,5.75c-2.43,0-4,1.86-4,4.35s1.55,4.35,4,4.35,4-1.88,4-4.35-1.57-4.35-4-4.35m0-1.88a6,6,0,0,1,6.15,6.22,6.15,6.15,0,1,1-12.3,0,6,6,0,0,1,6.15-6.22"/>
        <path fill={logoGrey} d="M56.93,14.24a4,4,0,0,0,4.13-4.15,3.9,3.9,0,0,0-4.13-4.17H54.57v8.31h2.36ZM52.46,4.07h4.47c3.75,0,6.29,2.49,6.29,6s-2.54,6-6.29,6H52.46v-12Z"/>
        <polygon fill={logoGrey} points="66.37 4.07 74.61 4.07 74.61 5.93 68.48 5.93 68.48 9.04 74.49 9.04 74.49 10.9 68.48 10.9 68.48 14.24 74.61 14.24 74.61 16.09 66.37 16.09 66.37 4.07"/>
        <path fill={logoGrey} d="M80.63,11.17h2.74V6.77Zm2.74,2.72H77.62V11.48l4.56-7.41h4.31v7.1H88V13.9H86.49v2.2H83.37V13.9Z"/>
        <path fill={logoGrey} d="M90.41,13.68c5.21-3.77,6.18-4.6,6.18-5.79,0-.83-0.78-1.26-1.71-1.26a4.46,4.46,0,0,0-3.15,1.32L90,5.89a6.63,6.63,0,0,1,4.87-2c2.83,0,4.87,1.59,4.87,4,0,1.84-1.32,3.41-4.54,5.5h4.63v2.7H90.41V13.68Z"/>
      </svg>
    );
  }
}

module.exports = BrandLogo;
